import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import { useAuth } from "@/lib/auth";
import { toast } from "sonner";

const NAVY = "#132a63";
const GREEN = "#16a34a";

export default function SociosLogin() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    const r = await login(email, password);
    setLoading(false);
    if (!r.ok) return toast.error(r.error);
    if (r.user.role !== "afiliado") { toast.error("Esta cuenta no es de socio."); return; }
    navigate("/socios");
  };

  return (
    <div style={wrap}>
      <Helmet><title>Acceso Socios — Mi Ángel Asís</title></Helmet>
      <div style={card} data-testid="socios-login-card">
        <div style={{ textAlign: "center", marginBottom: 16 }}>
          <div style={{ fontSize: 22, fontWeight: 800, color: NAVY }}>Portal de Socios</div>
          <p style={{ color: "#6b7280", marginTop: 4, fontSize: 14 }}>Accede a tu panel de comisiones</p>
        </div>
        <form onSubmit={onSubmit}>
          <label style={lbl}>Email</label>
          <input style={inp} type="email" value={email} onChange={(e) => setEmail(e.target.value)} data-testid="socios-login-email" />
          <label style={lbl}>Contraseña</label>
          <input style={inp} type="password" value={password} onChange={(e) => setPassword(e.target.value)} data-testid="socios-login-password" />
          <button type="submit" disabled={loading} data-testid="socios-login-submit"
            style={{ ...btn, background: NAVY, color: "white", marginTop: 18, opacity: loading ? 0.7 : 1 }}>
            {loading ? "Entrando…" : "Entrar"}
          </button>
        </form>
        <div style={{ textAlign: "center", marginTop: 14 }}>
          <Link to="/socios/registro" style={{ color: GREEN, fontSize: 13, fontWeight: 700 }} data-testid="socios-go-registro">¿Aún no eres socio? Únete gratis</Link>
        </div>
      </div>
    </div>
  );
}

const wrap = { minHeight: "100vh", background: NAVY, display: "flex", alignItems: "center", justifyContent: "center", padding: 20, fontFamily: "'Poppins',system-ui,sans-serif" };
const card = { background: "white", color: "#1f2937", borderRadius: 22, padding: "30px 26px", maxWidth: 420, width: "100%", boxShadow: "0 20px 60px rgba(0,0,0,0.3)" };
const lbl = { display: "block", fontSize: 12, fontWeight: 700, color: NAVY, marginTop: 12, marginBottom: 4 };
const inp = { width: "100%", padding: "11px 13px", borderRadius: 10, border: "1px solid #cbd5e1", fontSize: 15, fontFamily: "inherit", boxSizing: "border-box" };
const btn = { width: "100%", padding: "13px", borderRadius: 999, fontWeight: 800, border: "none", cursor: "pointer", fontSize: 15, fontFamily: "inherit" };
